/** 会话失效处理中：避免并发 401 重复弹窗、重复跳转 */
let authExpiryHandling = false;

export function tryBeginAuthExpiryHandling(): boolean {
  if (authExpiryHandling) return false;
  authExpiryHandling = true;
  return true;
}

export function isAuthExpiryHandling(): boolean {
  return authExpiryHandling;
}

export function resetAuthExpiryHandling(): void {
  authExpiryHandling = false;
}
